import { apiFetch } from './apiFetch';

const logService = {
  async getAuditLog(type, interval) {
    const url = `${process.env.REACT_APP_API_URL}/Log/GetAuditLog?type=${encodeURIComponent(type)}&interval=${encodeURIComponent(interval)}`;
    const res = await apiFetch(url, { method: "GET", credentials: "include" });

    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
    return await res.json();
  },

  async getLogsByDeviceName(deviceName) {
    const url = `${process.env.REACT_APP_API_URL}/Log/GetByDeviceName?deviceName=${encodeURIComponent(deviceName)}`;
    const res = await apiFetch(url, { method: "GET", credentials: "include" });

    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
    return await res.json();
  }
};

export default logService;
